import { TDeleteAccountReq } from "@sharedTypes/req.type";
import { TDeleteAccountRes } from "@sharedTypes/res.type";

import missingParametersError from "api/Error";
import axios from "axios";

export async function DeleteAccount(password: string) {
  const apiUrl = "/auth/deleteaccount";

  const body: TDeleteAccountReq = {
    password,
  };

  for (const [key, param] of Object.entries(body)) {
    if (param === undefined) throw missingParametersError(key);
  }

  const data: TDeleteAccountRes = await axios
    .post(apiUrl, body)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      throw err.response.data;
    });
  return data;
}
